import { render, staticRenderFns } from "./aiKefu.vue?vue&type=template&id=6450f26d&scoped=true"
import script from "./aiKefu.vue?vue&type=script&lang=js"
export * from "./aiKefu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450f26d",
  null
  
)

export default component.exports